import React, { useState, useEffect, useContext } from 'react';
import './AlarmHistory.css';
import alarmRed from '../../assets/alarm-red.png';
import formatDuration from '../../common/formatDuration';
import { CardAlarmHistoryContext } from '../../contexts/CardAlarmHistoryContext';
import logComponent from '../../common/logComponent';


export default function AlarmHistoryContent() {
  const [contentData, setContentData] = useState(null);
  const cardAlarmHistoryContext = useContext(CardAlarmHistoryContext);
  if (logComponent('AlarmHistoryContent')) { console.debug('AlarmHistoryContent rendered'); }

  useEffect(() => {
    if (logComponent('AlarmHistoryContent')) { console.debug('AlarmHistoryContent useEffect [cardAlarmHistoryContext.alarmHistory]');}
    setContentData(cardAlarmHistoryContext.alarmHistory ? { ...cardAlarmHistoryContext.alarmHistory } : null);
  }, [cardAlarmHistoryContext.alarmHistory]);

 
  return (contentData &&
    (contentData.alarmCount > 0 ?
      <div className="Alarm-History__main">
        <div className="Alarm-History__icon-area">
          <img className="Alarm-History__icon" src={alarmRed} alt="Alarm" />

          <div className="Alarm-History__icon-count">{contentData.alarmCount}</div>
        </div>
        <dl className="Alarm-History__info-list">
          <dt>Total alarms</dt>
          <dd>{contentData.alarmCount}</dd>
          <dt>Average response time</dt>
          <dd>{formatDuration(contentData.averageResponseTimeSec, 'hh:mm:ss')}</dd>
        </dl>
      </div> :
      <p className="Alarm-History__empty-message">No alarms reported</p>));
}